import ApiService from '@/services/api.service'

const baseUrl = '/api/prescriptions'

const PrescriptionService = {

	/**
	 * Création ou mise à jour d'une prescription
	 * 
	 * @param {Object} prescription
	 */
	savePrescription: async function(prescription) {

		if (prescription.id) {
			const response = await ApiService.post(baseUrl + '/'+ prescription.id, prescription)
			return response.data
		} else {
			const response = await ApiService.post(baseUrl, prescription)
			return response.data
		}
	}
}

export default PrescriptionService